import './markup-region.scss';
import './markup-region-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/image-analysis/markup/index.js